import { userActionsPermissions } from '@shared/utils';
import { ResourceAction } from '@src/types/common';

export const canViewBalancePanel = (): boolean => {
  return Boolean(userActionsPermissions(ResourceAction.VIEW_BALANCE_PANEL));
};
